import React, {useState} from 'react';

const ProgressBar = ({ label, value, color }) => {
  const [showToolTip, setShowToolTip] = useState(false);
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0 });
  
    const handleMouseMove = (e) => {
      const rect = e.currentTarget.getBoundingClientRect();
      const x = e.clientX - rect.left;
      setTooltipPosition({ x });
    };
  return (
    <div className="progress-bar"
              onMouseMove={handleMouseMove}
              onMouseEnter={() => setShowToolTip(true)}
              onMouseLeave={() => setShowToolTip(false)}>
      <div className="label">{label}</div>
      <div className="bar-container">
        <div className="bar" style={{ width: `${value}%`, backgroundColor: '#078ECE' }}></div>
        {showToolTip && (
                  <div className="tooltip" style={{ left: `${value}%` }}>
                    {value}%
                  </div>
                )}
      </div>
      
    </div>
  );
};

export default ProgressBar;